import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useMemo, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useUserRolesContext } from '../context/userRolesContext';

interface MenuItemProps {
    baseUrl: string;
    rutaObj: {
        id: string;
        icon: string | JSX.Element;
        name: string;
        url: string;
        subMenus?: Array<any>;
        permission: string[]; // en realidad: permisos requeridos
        idSubMenu?: string;
    };
    parentId: string;
}

const MenuItem: React.FC<MenuItemProps> = ({ baseUrl, rutaObj, parentId }) => {
    const [open, setOpen] = useState(false);
    const { userPermissions } = useUserRolesContext();

    const handleToggle = () => setOpen(!open);

    const hasAccess = (requiredPermissions?: string[]) => {
        // Público si viene vacío o ['']
        if (!requiredPermissions || requiredPermissions.length === 0) return true;
        if (requiredPermissions.every((p) => !p || p.trim() === "")) return true;

        // const current = userPermissions ?? [];
        const current = userPermissions.map((perm) => perm.codigoPermiso);
        return requiredPermissions.some((perm) => current.includes(perm));
    };

    const visibleSubMenus = useMemo(
        () => (rutaObj.subMenus ?? []).filter((sub) => hasAccess(sub.permission)),
        [rutaObj.subMenus, userPermissions]
    );

    // Si no tiene permiso al item padre, no se muestra
    if (!hasAccess(rutaObj.permission)) return null;

    if (rutaObj.subMenus && rutaObj.subMenus.length > 0) {
        // Si el módulo tiene submenús pero ninguno visible, no se muestra
        if (visibleSubMenus.length === 0) return null;

        return (
            <>
                <ListItemButton
                    onClick={handleToggle}
                    sx={{
                        backgroundColor: "white",
                        "&:hover": { backgroundColor: "#e0e0e0" },
                        borderBottom: "1px solid #ddd",
                        "&.active": { fontWeight: "bold", color: "black", backgroundColor: '#e0e0e0' },
                    }}
                >
                    <ListItemIcon>{rutaObj.icon}</ListItemIcon>
                    <ListItemText primary={rutaObj.name} />
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </ListItemButton>

                <Collapse in={open} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding sx={{ pl: 4 }}>
                        {visibleSubMenus.map((subModulo) => (
                            <ListItemButton
                                key={subModulo.id}
                                component={NavLink}
                                to={subModulo.url}
                                sx={{
                                    backgroundColor: "white",
                                    "&:hover": { backgroundColor: "#e0e0e0" },
                                    borderBottom: "1px solid #ddd",
                                    "&.active": { fontWeight: "bold", color: "black", backgroundColor: '#e0e0e0' },
                                }}
                            >
                                <ListItemIcon>{subModulo.icon}</ListItemIcon>
                                <ListItemText primary={subModulo.name} />
                            </ListItemButton>
                        ))}
                    </List>
                </Collapse>
            </>
        );
    }

    return (
        <ListItemButton
            component={NavLink}
            to={rutaObj.url}
            sx={{
                backgroundColor: "white",
                "&:hover": { backgroundColor: "#e0e0e0" },
                borderBottom: "1px solid #ddd",
                "&.active": { fontWeight: "bold", color: "black", backgroundColor: '#e0e0e0' },
            }}
        >
            <ListItemIcon>{rutaObj.icon}</ListItemIcon>
            <ListItemText primary={rutaObj.name} />
        </ListItemButton>
    );
};

export default MenuItem;